import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Module-level cache so we don't refetch on every render
let cache = null;
let cachePromise = null;

export function useShowcasePhotos() {
  const [photos, setPhotos] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    if (!cachePromise) {
      cachePromise = axios.get(`${API}/api/showcase-photos`)
        .then((res) => { cache = res.data || []; return cache; })
        .catch(() => { cache = []; return cache; });
    }
    cachePromise.then(setPhotos);
  }, []);
  return photos;
}

export function invalidateShowcaseCache() {
  cache = null;
  cachePromise = null;
}
